import { isDevMode } from '@angular/core';

import { Observable, of } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';

type GRpcReturnType<
  T extends ReturnType<
    {
      toObject(): {
        IsOk?: boolean;
        Error?: any;
        Value?: any;
      };
    }['toObject']
  >,
> = T extends {
  IsOk?: boolean;
  Error?: any;
  Value?: infer V;
}
  ? V
  : null;

export function grpcOperator<
  T extends {
    toObject(): {
      IsOk?: boolean;
      Error?: any;
      Value?: any;
    };
  },
>(request?: any): (source: Observable<T>) => Observable<GRpcReturnType<ReturnType<T['toObject']>>> {
  return (source: Observable<T>) => {
    return source.pipe(
      switchMap((x) => {
        const obj = x.toObject();
        if (obj.IsOk) {
          return of(obj);
        } else {
          if (request) {
            throw { ...obj.Error, Request: JSON.parse(JSON.stringify(request)) };
          }
          throw obj.Error;
        }
      }),
      filter((x) => !!x.IsOk),
      map((x) => (Object.prototype.hasOwnProperty.call(x, 'Value') ? x.Value : null)),
    );
  };
}

export function log() {
  return function (target: any, key: string, descriptor: PropertyDescriptor) {
    const originalMethod = descriptor.value;

    descriptor.value = function (...args: Array<any>) {
      const functionName = key;
      if (isDevMode() && args.length > 0) {
        console.log(`GRPC method: "${functionName}" with params: ${JSON.stringify(args)}`);
      }
      const result = originalMethod.apply(this, args) as Observable<any>;
      return result;
    };

    return descriptor;
  };
}
